export const headers = [
  { name: 'Color', key: 'color' },
  { name: 'Service name', key: 'name' },
  { name: 'Assign to', key: 'assignTo' },
  { name: 'Clinic(s)', key: 'clinics' },
  { name: '', key: 'buttons' },
];
